import React from "react";
import { Typography } from "antd";

const { Text } = Typography;
const TextBody = ({ text, ...props }) => {
  return <Text {...props}>{text}</Text>;
};

export default TextBody;
